import { render, staticRenderFns } from "./PatientEditView.vue?vue&type=template&id=de907a44&"
import script from "./PatientEditView.vue?vue&type=script&lang=ts&"
export * from "./PatientEditView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports